import dayjs from 'dayjs';

import { DateFormat } from 'enums';

export const convertNumberToTime = (duration?: number) => {
  if (!duration) return '00:00:00';

  return dayjs.duration(duration * 1000).format(DateFormat.PLAYER);
};
